// extracted by mini-css-extract-plugin
export default {"app_d":"Approved_app_d__wlAzR","app":"Approved_app__J0++5","app_l":"Approved_app_l__JfVsq"};